export default __webpack_public_path__ + "static/media/pc ai@3x.47eb6a4d.png";